import React from 'react';

const Contact = () => {
  return (
    <section id="contact-section">
      <div className="container">
        <div className="heading-section">
          <h1 className="big">Centre d'intérêt</h1>
          <h2>Mes centres d'intérêts</h2>
        </div>
        <div style={{maxWidth: '900px', margin: '0 auto'}}>
          <p>
            <strong>La cybersécurité</strong>, et plus particulièrement le <strong>pentest</strong>, est au cœur de mes centres d'intérêt. Passionné par ce domaine, je consacre une partie de mon temps à lire des livres spécialisés pour approfondir mes connaissances et me tenir à jour sur les dernières avancées en matière de sécurité informatique.
          </p>

          <p>
            Par ailleurs, le <strong>développement</strong> et la <strong>programmation</strong> me passionnent également : j'aspire à créer mes propres outils de pentest, combinant mes compétences techniques et ma créativité.
          </p>

          <p>
            Plus récemment, je me suis passionné pour l'<strong>électronique embarquée</strong>. Avec mon <strong>ESP32</strong>, mes capteurs, écrans, LEDs et ma breadboard, je m'amuse à concevoir des circuits et de petits projets hardware sur mon temps libre — comme piloter une LED depuis une page web via un réseau WiFi créé par l'ESP32. Je possède également un <strong>LilyGo T-Embed CC1101</strong> qui me permet d'expérimenter avec les <strong>cartes NFC</strong>, le <strong>WiFi</strong> et le <strong>Bluetooth</strong> dans un cadre d'apprentissage de la sécurité radio.
          </p>

          <p>
            Ce que je souhaite avant tout, c'est continuer à concilier ma passion pour l'informatique avec le <strong>sport</strong>, un domaine souvent perçu comme incompatible avec celui des technologies. Pourtant, j'ai toujours aimé faire les deux et je veux prouver qu'il est possible de travailler dans un domaine aussi exigeant que l'informatique tout en restant actif physiquement.
          </p>

          <p>
            J'ai pratiqué le <strong>basket</strong>, une activité que j'ai adorée, et je m'investis également dans la <strong>musculation</strong>, une discipline qui m'a appris la persévérance et la rigueur.
          </p>

          <p>
            En dehors de l'informatique et du sport, je suis aussi un grand amateur de <strong>jeux vidéo</strong>. Les jeux d'histoires comme <em>Red Dead Redemption</em> ou <em>God of War</em> m'ont particulièrement marqué. Ces expériences immersives ne se limitent pas au divertissement : <em>God of War</em>, par exemple, a éveillé en moi une véritable passion pour la <strong>mythologie grecque</strong> et <strong>nordique</strong>, que j'ai adoré découvrir et approfondir.
          </p>

          <p>
            Durant mon année de terminale, j'ai également découvert une forte affinité pour les <strong>mathématiques</strong>, un domaine que je trouve à la fois fascinant et complexe. Cette découverte a renforcé mon admiration pour les <strong>sciences</strong> en général.
          </p>

          <p>
            D'ailleurs, avant de me passionner pour la cybersécurité, je rêvais de devenir <strong>astrophysicien</strong>. L'<strong>astrophysique</strong>, et plus largement l'exploration de l'espace, ont toujours exercé une grande influence sur moi. Bien que ma vocation se soit orientée vers la cybersécurité, ma fascination pour l'espace continue de vivre en moi, et je m'informe régulièrement sur ce domaine captivant.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Contact;
